import { IndustrialProcessSchema, ProcessStep } from "../types";

export const computeManTimeCost = ({
  quantity,
  reworkRatio,
  processStep: {
    manTime,
    manHourlyPrice,
    industrialProcess,
    partsToControlRatio,
    partsToPackQuantity,
    packingHourlyPrice,
    isFixedCostPerSeries,
  },
}: {
  quantity: number;
  reworkRatio: number | null;
  processStep: ProcessStep;
}) => {
  const sanitizedReworkRatio = reworkRatio || 0;

  const isPackingProcess = industrialProcess === IndustrialProcessSchema.enum.PACKING;

  const isControlProcess = industrialProcess === IndustrialProcessSchema.enum.CONTROL;

  const isAssemblingProcess = industrialProcess === IndustrialProcessSchema.enum.ASSEMBLING;

  if (isPackingProcess) {
    const totalPackingTime = (partsToPackQuantity || 0) * (manTime || 0);

    return (
      (((totalPackingTime || 0) * (packingHourlyPrice ?? 0)) / 60) *
      (1 + sanitizedReworkRatio / 100)
    );
  }

  if (isControlProcess) {
    const totalControlTime = (manTime || 0) * quantity * ((partsToControlRatio || 0) / 100);

    return (((totalControlTime || 0) * manHourlyPrice) / 60) * (1 + sanitizedReworkRatio / 100);
  }

  if (isAssemblingProcess) {
    const totalAssemblingTime = (manTime || 0) * (isFixedCostPerSeries ? 1 : quantity);

    return (((totalAssemblingTime || 0) * manHourlyPrice) / 60) * (1 + sanitizedReworkRatio / 100);
  }

  const totalManTime = (manTime || 0) * quantity;

  return (((totalManTime || 0) * manHourlyPrice) / 60) * (1 + sanitizedReworkRatio / 100);
};
